var _style, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgItemLabelOn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 39.2 47.6",
    style: {
      enableBackground: "new 0 0 39.2 47.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{enable-background:new    ;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.9,17.7l-8.4,12c-0.4,0.6-0.9,1.1-1.5,1.5s-1.3,0.6-2,0.6H6.2c-0.8,0-1.5-0.3-2.1-0.9c-0.6-0.6-0.9-1.3-0.9-2.1v-22 c0-0.8,0.3-1.5,0.9-2.1C4.6,4,5.3,3.7,6.2,3.7H27c0.7,0,1.4,0.2,2,0.6s1.1,0.9,1.5,1.5L38.9,17.7L38.9,17.7z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.9,32.9v10.8H4.6V32.9H5.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4,34H7.1v-1.2h8V34h-3.3v9.6h-1.4V34z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9,38.6h-4.2v3.9h4.7v1.2h-6.1V32.9h5.8V34h-4.4v3.4h4.2V38.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3,38.9c-0.1-1.5-0.2-3.3-0.2-4.7h0c-0.4,1.3-0.8,2.6-1.4,4.1l-1.9,5.2h-1.1L27,38.4c-0.5-1.5-0.9-2.9-1.2-4.2h0 c0,1.3-0.1,3.2-0.2,4.8l-0.3,4.6h-1.3l0.8-10.8h1.8l1.8,5.2c0.4,1.3,0.8,2.5,1.1,3.6h0c0.3-1.1,0.7-2.3,1.1-3.6l1.9-5.2h1.8 l0.7,10.8h-1.4L33.3,38.9z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgItemLabelOn);
export default __webpack_public_path__ + "static/media/item-label-on.349daa3fc5e644eeb18b67528339ed81.svg";
export { ForwardRef as ReactComponent };